import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

// import { BASE_URL, OrganizationId, AuthToken } from '/features/storeconfig'
import axios from "axios";


const initialState = {
    entities: [],
    status: 'idle', // idle loading success fail  
    error: null
}
/**
 * 
 * ~~ = ignore
 * ~_~ = delete/set to default value
 */
const PLATFORM = '../../WsWebServicePlatform/'
const WELLSUITE = '../../WsWebServiceWellSuite/';
// Participant/Misc/Types/Get/{AuthToken}/	
// Participant/Misc/Type/Update/{AuthToken}/{ParticipantErrorMessagesGuid}/{ErrorMessagesName}/{ErrorMessagesDescription}/	
// Participant/Misc/Type/Delete/{AuthToken}/{ParticipantErrorMessagesGuid}/	
// Participant/Misc/Type/Create/{AuthToken}/{ErrorMessagesName}/{ErrorMessagesDescription}/	
export const fetchErrorMessages = createAsyncThunk('errormessages/get', async (incomingVariable, thunkAPI) => {
    
    try {
        const response = await axios.get(WELLSUITE + 'GetViewInstancePublic/' + incomingVariable.groupGuid + '/'+ incomingVariable.languageID + "/8846E98A-288A-40D7-8FF1-5D4A58538F71"+'/')
        const data = await response.data.Success ? response.data : []

        return data
    } catch (err) {
        console.log('error', err)
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})


const errormessagesSlice = createSlice({
    name: 'errormessages',
    initialState,
    reducers: {        
        errormessagesClear(state, action) {
          
            state.status = "idle"
            
        }
    },
    extraReducers(builder) {
        builder
            //
            .addCase(fetchErrorMessages.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchErrorMessages.fulfilled, (state, action) => {
                const loadedData = action.payload.Info[0].ViewInstanceData[0].ErrorMessages.Values
                state.entities = loadedData
                state.status = 'success'
            })
            .addCase(fetchErrorMessages.rejected, (state, action) => {
                state.error = action.error.message
                console.log('failed')
            })
            
            
    }
})

export const { errormessagesClear} = errormessagesSlice.actions

export default errormessagesSlice.reducer

export const selectErrorMessagesEntities = (state) => state.errormessages.entities

export const selectErrorMessages = createSelector(selectErrorMessagesEntities, (entities) =>
    Object.values(entities)
)

export const selectErrorMessagesByNegativeCode = (state, ErrorMessagesId) => {
    return state.errormessages.entities.filter((x)=>{return x.MessageTypeErrorCode === ErrorMessagesId})
}

export const selectErrorMessagesByKeyName = (state, ErrorMessagesKeyName) => {
    return state.errormessages.entities.filter((x)=>{return x.MessageTypeKeyName === ErrorMessagesKeyName})
}

